import React, { IframeHTMLAttributes, useEffect } from 'react';
import { EXPERIENCE_DOMAIN_CONFIG } from '../../constants';
import { IFramePermissionConfig } from '../utils/iframePermissionMappings';
import { iOS } from '../../common/utils/browserDetect';
import { SessionStore } from '../../constants/sessionStore';

/** Component for loading iframe */
const IFrame = (props: IframeHTMLAttributes<HTMLIFrameElement>): React.JSX.Element => {
  useEffect(() => {
    const iframeElement: HTMLIFrameElement = document.getElementById(`uuid_${props.id}`) as HTMLIFrameElement;

    const onLoadHandler = (): void => {
      try {
        if (iframeElement.contentWindow) {
          sessionStorage.setItem(SessionStore.launchurl, iframeElement.contentWindow.location.href);
        }
      } catch (e) {
        console.error('iframe window access permission error');
      }
    };

    iframeElement.addEventListener('load', onLoadHandler);

    return (): void => {
      iframeElement.removeEventListener('load', onLoadHandler);
    };
  });

  const hostname = window.location.hostname as EXPERIENCE_DOMAIN_CONFIG;
  let allow = 'geolocation; microphone; camera';
  const environment = IFramePermissionConfig[hostname];
  if (environment) {
    const origin = window.location.origin;
    allow = `${environment.microphone} ${origin};${environment.camera} ${origin};${environment.geolocation} ${origin}`;
  }

  return (
    <iframe
      id={`uuid_${props.id}`}
      title={props.title}
      src={props.src}
      allow={allow}
      style={iOS() ? { minHeight: '-webkit-fill-available' } : {}}
    />
  );
};

export default IFrame;
